const ServiceIcon2 = () => {
    return (
        <div>
            <svg width={30} height={30} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.32 14.9483H19.82V14.4483V9.57372V9.07372H19.32H14.948V4.70209V4.20209H14.448H9.57709H9.07709V4.70209V9.07372H4.70359H4.20359V9.57372V14.4483V14.9483H4.70359H9.07709V19.32V19.82H9.57709H14.448H14.948V19.32V14.9483H19.32ZM3.23884 0.621094H20.7836C22.2263 0.621094 23.401 1.79587 23.401 3.23922V20.7821C23.401 22.2263 22.2263 23.401 20.7836 23.401H3.23884C1.79581 23.401 0.621094 22.2259 0.621094 20.7821V3.23922C0.621094 1.79595 1.79603 0.621094 3.23884 0.621094Z" fill="white" stroke="#232323"/>
            </svg>
        </div>
    );
};

export default ServiceIcon2;